import {Select} from 'antd';
import {useContext, useMemo, useState} from 'react';

import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {MainFilterContext} from '../../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../../provider/main-filter/main-filter-type';
import {useReviewPhrasesSearch} from '../../../../../service/reivew-analysis/review-phrases/review-phrases-hook';
import {debounce} from '../../../../../util/function';
import {reviewAnalysisAutocompleteLimit} from '../drawer-filter/drawer-filter-const';
import {compareSelectOptions, renderSelectOption} from '../drawer-filter/drawer-filter-helper';
import {SelectOptionType} from '../drawer-filter/drawer-filter-type';

type PropsType = {
    value?: Array<string>;
    onChange?: (value: Array<string>) => void;
};

export function PhraseSelect(props: PropsType): JSX.Element {
    const {value, onChange} = props;

    const {shortLocaleName} = useLocale();

    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const [q, setQ] = useState<string>('');
    const {result: phraseResult, isInProgress: isPhraseResult} = useReviewPhrasesSearch(
        {
            count: reviewAnalysisAutocompleteLimit,
            page: 1,
            q,
        },
        mainFilterKey
    );
    const phraseOptions: Array<SelectOptionType<string>> = useMemo((): Array<SelectOptionType<string>> => {
        return (phraseResult || [])
            .map<SelectOptionType<string>>(
                (phrase: string): SelectOptionType<string> => ({
                    id: phrase,
                    name: phrase,
                })
            )
            .sort(compareSelectOptions<string>(shortLocaleName));
    }, [phraseResult, shortLocaleName]);

    return (
        <Select<Array<string>>
            disabled={false}
            loading={isPhraseResult}
            mode="multiple"
            // eslint-disable-next-line no-undefined
            notFoundContent={q === '' ? null : undefined}
            onBlur={() => setQ('')}
            onChange={onChange}
            onSearch={debounce<[string]>(setQ, 300)}
            placeholder={<Locale stringKey="REVIEWS_ANALYSIS__FORM__INPUT__PHRASES__PLACEHOLDER" />}
            value={value}
        >
            {phraseOptions.map(renderSelectOption)}
        </Select>
    );
}
